import apiClient from "./client";

export const getCourseTrainings = async ({ courseId, language = "en" }) => {
  const response = await apiClient.get(`/courses/${courseId}/trainings`, {
    params: { language },
  });
  return response.data;
};

export const getCourseTrainingById = async ({
  courseId,
  trainingId,
  language = "en",
}) => {
  const response = await apiClient.get(`/courses/${courseId}/trainings/${trainingId}`, {
    params: { language },
  });
  return response.data;
};
